import { useState } from 'react';
import type { Tenant } from '@/api/schemas/tenants';
import { TenantApi } from '@/modules/tenants/services/api';

/** Suspends a tenant via PATCH /tenants/{id}/status. Returns the updated
 * tenant on success, or sets the error state and re-throws on failure. */
export function useTenantSuspend(tenant: Tenant | null) {
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const suspend = async (): Promise<Tenant> => {
    if (!tenant) throw new Error('No tenant to suspend');
    setPending(true);
    setError(null);
    try {
      const result = await TenantApi.changeStatus(tenant.id, {
        status: 'suspended',
        reason: 'Suspended from the platform console',
      });
      // The API answers with the shared `{ data, meta }` envelope; the tenant is
      // the `data` member.
      return result.data;
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setPending(false);
    }
  };

  return { pending, error, suspend };
}
